import React, { useContext } from "react";
import CaseModal from "../components/CaseModal";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { loginRequest, getParam, Api, VerifiedEntity, Case, useSessionId, useAuthProvider, Loader, getSessionId, DataContext, callApi } from '@cloudpremise/portal_core';
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";
import DataTable from  "@cloudpremise/portal_core/src/themes/mui/examples/Tables/DataTable";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import { useMsal } from '@azure/msal-react';
import { CasesState } from "../types";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Grid from "@mui/material/Grid";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import CloseIcon from '@mui/icons-material/Close';
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import Snackbar from '@mui/material/Snackbar';

let loadUserCases = null;
const Home = (props) => {
    const dataProvider = useContext(DataContext);
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const [ authorized, authType, token ] = useAuthProvider();
    const { instance, accounts } = useMsal();
    let account = instance.getActiveAccount();
    const secureLink = token;
    let heading = "Enter Your Email Address to Continue";
    let loadingLinkInfo = false;
    let footer = "Unauthenticated Screen";
    if(typeof(secureLink) === "string" && secureLink.length > 0 && secureLink !== "null"){
        heading = "Please wait while we verify your secure link";
        loadingLinkInfo = true;
        footer = "Authenticated Screen";
        if(loadUserCases === null){
            loadUserCases = loadingLinkInfo;
        }
    }else if(account !== null){
        heading = "Please wait while we verify your secure link";
        loadingLinkInfo = true;
        footer = "Authenticated Screen";
        if(loadUserCases === null){
            loadUserCases = loadingLinkInfo;
        }
    }
    
    
    let verifiedEntity: VerifiedEntity = null;
    let verifiedEntityItem = localStorage.getItem("verified_entity");
    if(verifiedEntityItem !== null){
        verifiedEntity = JSON.parse(verifiedEntityItem);
        heading = "You are recognized as "+verifiedEntity.name+" with Id: "+verifiedEntity.sub;
        footer = "Case Management Screen";
    }else if(account !== null){
        account = accounts[0];
        heading = "You are recognized as "+account.name+" with Microsoft Id: "+account.localAccountId;
        footer = "Case Management Screen";
    }
    
    const defaultState = {
        email: "",
        loading: loadingLinkInfo,
        errorMessage: null,
        loadCases: loadingLinkInfo,
        verifiedEntity: verifiedEntity,
        caseModal: false,
        editModal: false,
        caseRow: null,
        checkEmail: false,
        cases: [],
        closedCases: [],
        searchText: "",
        sortColumn: 'Id',
        sortColumnDirection: {
			Id: 'desc',
		},
        items: [],
        selection: [],
        linkExpired: false,
        closeModal: false,
        saving: false,
        formSaved: false
    };

    const [state, setState] = React.useReducer((state: CasesState, newState: Partial<CasesState>) => ({
        ...state,
        ...newState
    }), defaultState);

    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing"+window.location.search, { replace: true });
        }
        if(authorized && (authType !== "link" && authType !== "microsoft" && authType !== "google" && authType !== "github" && authType !== "facebook")){
            return navigate("/auth-not-supported", { replace: true });
        }
        if(state.linkExpired){
            window.history.replaceState(null, document.title, props.basename+"/auth/login-link"+window.location.search);
            return navigate("/auth/login-link"+window.location.search, { replace: true });
        }
        if(!authorized || !state.loadCases && !loadUserCases){
            return;
        }
        loadUserCases = false;
        loadCases(false);
        loadCases(true);
    });

    function onNewCaseModal(status = true, caseRow = null){
        const cases = state.cases;
        const closedCases = state.closedCases;
        let loadCases = false;
        if(caseRow !== null){
            cases.map((item: Case, key) => {
                if(item.Id === caseRow.Id){
                    if(item.IsClosed !== caseRow.IsClosed){
                        loadCases = true;
                    }
                    cases[key] = caseRow;
                }
                return null;
            });
            closedCases.map((item: Case, key) => {
                if(item.Id === caseRow.Id){
                    if(item.IsClosed !== caseRow.IsClosed){
                        loadCases = true;
                    }
                    closedCases[key] = caseRow;
                }
                return null;
            })
        }
        setState({
            caseModal: status,
            editModal: status,
            caseRow: null,
            cases: cases,
            loadCases: loadCases,
            closedCases: closedCases
        });
    }
    function onNewCaseModalSuccess(caseRow){
        let newCases = [caseRow];
        newCases = newCases.concat(state.cases);
        setState({
            caseModal: false,
            editModal: false,
            caseRow: null,
            cases: newCases,
            formSaved: true
        });
    }
    async function loadCases(isClosed = false){
        const caseId = getParam("caseId");
        let headers = {};
        let method = 'GET';
        let route = '/v1/servicedesk/sfcase';
        const params = {
            IsClosed: isClosed
        }
        const object: Case = {
            sObjectTypeName: "Case",
            url: route,
            method: method,
            headers: headers,
            params: params
        };

        callApi(dataProvider, object).then((response: any) => {
            let result = [];
            if(response.numberOfResults > 0){
                result = response.result;
            }
            let casesStateKey = 'cases';
            if(isClosed){
                casesStateKey = 'closedCases';
            }
            let newState = {
                [casesStateKey]: result,
                loading: false
            };
            if(typeof(caseId) === "string" && caseId.length > 0 && caseId !== "null"){
                result.map((caseObj) => {
                    if(caseId === caseObj.Id){
                        newState['caseRow'] = caseObj;
                        newState['editModal'] = true;
                        let search = window.location.search.replace("caseId="+caseId+"&", "");
                        search = window.location.search.replace("caseId="+caseId, "");
                        window.history.replaceState(null, document.title, window.location.pathname+search);
                    }
                    return null;
                });
            }
            setState(newState);
        }).catch((err) => {
            console.log(err);
            let errorMessage = null;
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                errorMessage = err.error;
            }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                errorMessage = err.message;
            }
            setState({
                linkExpired: (errorMessage === null),
                errorMessage: errorMessage,
                loading: false
            });
        });
        setState({
            loading: true,
            loadCases: false
        });
    }
    function formatDateTime(date){
        if(!date || date.length <= 0){
            return "";
        }
        return moment(new Date(date)).format("M/D/YYYY hh:mm A");
    }
    function getItems(isClosed = false){
        let openColumns = [];
        if(!isClosed){
            openColumns.push({ Header: "Status", accessor: "Status" })
        }
        const tableData = {
            columns: [
                { Header: "CaseNumber", accessor: "CaseNumber", width: "20%" },
                { Header: "Subject", accessor: "title", width: "25%" },
                { Header: "Description", accessor: "desc" },
                ...openColumns,
                { Header: (isClosed ? "Closed Date" : "Open Date"), accessor: (isClosed ? "ClosedDate" : "CreatedDate") },
                { Header: "Actions", accessor: "actions", width: "12%", sortable: false },
            ],
            rows: []
        };
        let cases = state.cases;
        if(isClosed){
            cases = state.closedCases;
        }
        let items = [];
        if(state.loading){
            return tableData;
        }
        if(cases === null){
            return tableData;
        }
        if(state.searchText.length > 0){
            const filteredItems = cases.filter((item) =>
                RegExp(state.searchText, 'i').test(item.Subject)
            );
            filteredItems.map((caseObj, key) => {
                const itemObj = {
                    ...caseObj,
                    key: (key + 1),
                    id: caseObj.Id,
                };
                let desc = "";
                if(caseObj.hasOwnProperty("Description")){
                    desc = caseObj.Description;
                    if(desc.length > 50){
                        desc = desc.substring(0, 50)+"...";
                    }
                }
                let title = "";
                if(caseObj.hasOwnProperty("Subject")){
                    title = caseObj.Subject;
                    if(title.length > 50){
                        title = title.substring(0, 50)+"...";
                    }
                }
                items.push({
                    ...itemObj,
                    title: title,
                    desc: desc,
                    onClick: () => { handleRowAction(itemObj, {value: "edit"}) }
                });
                return null;
            });
        }else{
            cases.map((caseObj: any, key) => {
                const itemObj = {
                    ...caseObj,
                    key: (key + 1),
                    id: caseObj.Id,
                };
                let desc = "";
                if(caseObj.hasOwnProperty("Description")){
                    desc = caseObj.Description;
                    if(desc.length > 50){
                        desc = desc.substring(0, 50)+"...";
                    }
                }
                let title = "";
                if(caseObj.hasOwnProperty("Subject")){
                    title = caseObj.Subject;
                    if(title.length > 50){
                        title = title.substring(0, 50)+"...";
                    }
                }
                items.push({
                    ...itemObj,
                    title: title,
                    desc: desc,
                    CreatedDate: formatDateTime(itemObj.CreatedDate),
                    ClosedDate: formatDateTime(itemObj.ClosedDate),
                    onClick: () => { handleRowAction(itemObj, {value: "edit"}) },
                    actions: (
                        <>
                            <MDButton
                                variant="gradient"
                                color="info"
                                onClick={() => handleRowAction(caseObj, {value: "edit"})}
                                iconOnly
                                style={{marginRight: "5px"}}
                                size="small"
                            >
                                {(caseObj.isClosed ? <PreviewIcon /> : <EditIcon />)}
                            </MDButton>
                            {
                                user !== null && user.superAdmin ?

                                    !isClosed ?
                                        <MDButton
                                            variant="gradient"
                                            color="error"
                                            onClick={() => handleRowAction(caseObj, {value: "close"})}
                                            iconOnly
                                            size="small"
                                        >
                                            <CloseIcon />
                                        </MDButton>
                                    :
                                        null
                                :
                                    null
                            }
                        </>
                    )
                });
                return null;
            });
        }
        tableData.rows = items;
        return tableData;
        
    }
    function handleChanged(event, data){
		setState({
            selection: data.selection
        });
	}
    function handleSort(sortColumn, ...rest){
		if (props.log) {
			props.log('sort')(sortColumn, ...rest);
		}

		const sortProperty: string = sortColumn.property;
		const sortDirection: string = sortColumn;
		const newState = {
            ...state,
			sortColumn: sortProperty,
			sortColumnDirection: {
				[sortProperty]: sortDirection,
			},
			items: [...state.items],
		};

		// needs to work in both directions
		newState.items = newState.items.sort((a, b) => {
			let val = 0;

			if (a[sortProperty] > b[sortProperty]) {
				val = 1;
			}
			if (a[sortProperty] < b[sortProperty]) {
				val = -1;
			}

			if (sortDirection === 'desc') {
				val *= -1;
			}

			return val;
		});

        setState(newState);
	}
    function handleRowAction(item, action){
        let newState = {
            [action.value+"Modal"]: true
        };
        if(item !== null){
            newState['caseRow'] = item;
        }
        setState(newState);      
	}
    function getTableRowOptions(isClosed = false){
        const options = [
            {
                id: 0,
                label: (isClosed ? 'View' : 'Edit'),
                value: 'edit',
            }
        ];
        if(!isClosed){
            options.push({
                id: 1,
                label: 'Close Case',
                value: 'close',
            });
        }
        return options;
    }
    function handleRowClick(event, item){
        setState({
            caseRow: item
        });
	}
    function renderCases(){
        const tableDataItems = getItems();
        const tableDataClosedItems = getItems(true);
        return (
            <div className="slds-custom-table-container">
                <Box pl="20px" sx={{ display: 'flex' }}>
                    <MDButton
                        variant="gradient"
                        color="info"
                        onClick={() => onNewCaseModal()}
                    >
                        New Case
                    </MDButton>
                </Box>
                <DataTable
                    table={tableDataItems}
                    canSearch
                    rowsCount={tableDataItems.rows.length}
                />
                <Box pl="20px" sx={{ display: 'flex' }}>
                    <MDTypography variant="h4" fontWeight="medium" mb={2}>
                        Closed Cases
                    </MDTypography>
                </Box>
                <DataTable
                    table={tableDataClosedItems}
                    rowsCount={tableDataClosedItems.rows.length}
                    canSearch
                />
            </div>
        )
    }
    function onConfirmationModal(status = false){
        setState({
            closeModal: status
        });
    }
    async function onCloseModalSuccess(){
        const { caseRow, loading } = state;
        if(caseRow === null && loading){
            return;
        }
        const requestData = {};
        let headers = {};
        let method = 'PATCH';
        let route = '/v1/servicedesk/sfcase/'+caseRow.Id;
        if(caseRow.IsClosed){
            requestData['Status'] = 'New';
            requestData['IsClosed'] = false;
        }else{
            requestData['Status'] = 'Closed';
            requestData['IsClosed'] = true;
        }

        const object: Case = {
            sObjectTypeName: "Case",
            url: route,
            method: method,
            headers: headers,
        };

        callApi(dataProvider, object).then((response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            onNewCaseModal(false, result);
        }).catch((err) => {
            setState({
                loading: false,
                closeModal: false
            });
        });

        setState({
            loading: true,
            closeModal: false
        });
    }
    if(!authorized){
        return null;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={12} lg={12} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    textAlign="left"
                                    pt={2}
                                >
                                    {
                                        config !== null && config.debug === true ?
                                            <Box pl="20px" sx={{ display: 'flex' }}>
                                                <MDTypography variant="h4" fontWeight="medium" mb={2}>
                                                    {heading}
                                                </MDTypography>
                                            </Box>
                                        :
                                            null
                                    }
                                    <div className="slds-p-around_medium">
                                        {
                                            ((state.verifiedEntity !== null || account !== null) && !state.loading) ?
                                                state.errorMessage !== null ?
                                                    <Stack mb={2}>
                                                        <Alert severity="error">Unable to load cases. {state.errorMessage}</Alert>
                                                    </Stack>
                                                :
                                                    renderCases()
                                            :
                                            (loadingLinkInfo || state.loading) ?
                                                <Loader pl={2} pb={2} color="info" />
                                            :
                                            <>
                                                {
                                                    state.errorMessage !== null ?
                                                        <Stack mb={2}>
                                                            <Alert severity="error">{state.errorMessage}</Alert>
                                                        </Stack>
                                                    :
                                                        null
                                                }
                                                {
                                                    (state.verifiedEntity === null && account === null) ?
                                                        state.loading ?
                                                            <Loader color="info" />
                                                        :
                                                        null
                                                    :
                                                    null
                                                }
                                            </>
                                        }
                                    </div>
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
                {
                    (state.caseModal || state.editModal) ?
                        <CaseModal
                            open={(state.caseModal || state.editModal)}
                            item={state.caseRow}
                            onCancel={(caseRow) => onNewCaseModal(false, caseRow)}
                            onSuccess={(caseRow) => onNewCaseModalSuccess(caseRow)}
                            verifiedEntity={state.verifiedEntity}
                            basename={props.basename}
                        />
                    :
                    null
                }
                {
                    state.closeModal ?
                        <Confirmation
                            open={state.closeModal}
                            item={state.caseRow}
                            onCancel={() => onConfirmationModal(false)}
                            onSuccess={onCloseModalSuccess}
                            message={(
                                state.caseRow.IsClosed ?
                                    "Are you sure you want to open this case?"
                                :
                                    "Are you sure you want to close this case?"
                            )}
                            saving={state.saving}
                            errorMessage={state.errorMessage}
                        />
                    :
                    null
                }
                {
                    state.formSaved ?
                        <Snackbar
                            open={state.formSaved}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            autoHideDuration={2000}
                            onClose={() => setState({formSaved: false})}
                            message="Your case have been saved."
                        />
                    :
                        null
                }
            </MDBox>
        </DashboardLayout>
    )
};

export default Home;